import {
  Textarea as MantineTextarea,
  type TextareaProps as MantineTextareaProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type TextareaProps = CoreComponentProps<MantineTextareaProps, 'textarea'>;

export function Textarea({ testId, view = "all", ...rest }: TextareaProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineTextarea data-testid={testId} {...rest} />;
}
